module.exports = __webpack_public_path__ + "static/merch12Front-7c50b39602b0c96059190c830d1fe63e.png";